import React from 'react';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useOrdersMetricsSection} from './OrdersMetricsSection.hook';

interface OrdersMetricsSectionProps {
  currentUserCompetency: string;
  newOrdersCountFrontline: number | null;
  newOrdersCountGen0: number | null;
  newOrdersCountOrg: number | null;
  ordersCountFrontline: number | null;
  ordersCountGen0: number | null;
  ordersCountOrg: number | null;
  onShowInfoPopover: () => void;
  onShowReport: () => void;
  allOrdersOrgCount: number | null;
  allOrdersReport: () => void;
}

export const OrdersMetricsSection = ({
  currentUserCompetency = '',
  newOrdersCountFrontline = null,
  newOrdersCountGen0 = null,
  newOrdersCountOrg = null,
  ordersCountFrontline = null,
  ordersCountGen0 = null,
  ordersCountOrg = null,
  onShowInfoPopover = () => {},
  onShowReport = () => {},
  allOrdersOrgCount = null,
  allOrdersReport = () => {},
}: OrdersMetricsSectionProps) => {
  const {listItems, onInfoPress, onItemPress, ts} = useOrdersMetricsSection({
    currentUserCompetency,
    newOrdersCountFrontline,
    newOrdersCountGen0,
    newOrdersCountOrg,
    ordersCountFrontline,
    ordersCountGen0,
    ordersCountOrg,
    onShowInfoPopover,
    onShowReport,
    allOrdersOrgCount,
    allOrdersReport,
  });
  return (
    <MetricSection
      analyticsTitle="Orders Metrics"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Orders Metrics Section Information button',
      )}
      testID={MetricsSection.metricSectionOrdersMetric}
      title={ts('heading', 'Orders Metrics')}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
    />
  );
};

export default OrdersMetricsSection;
